import React from "react";
import {Route, Switch, withRouter} from "react-router-dom";
import LecturerRegistration from "./registration";
import LecturerPassword from "./password";
import LecturerConfirmation from "./confirmation";
import LecturerSignIn from "./sign-in";

class LecturerIndex extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Switch>
                <Route path='/lecturers/registration' component={LecturerRegistration}/>
                <Route path='/lecturers/password' component={LecturerPassword}/>
                <Route path='/lecturers/confirmation' component={LecturerConfirmation}/>
                <Route path='/lecturers/sign-in' component={LecturerSignIn}/>
            </Switch>
        )
    }

}

export default withRouter(LecturerIndex);
